import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) {
          seconds--;
        } else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="sticky top-0 z-50 bg-gradient-to-r from-[#D4915D] to-[#C4824D] text-white py-3 px-4 shadow-lg" data-id="element-33">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-3 text-center md:text-left" data-id="element-34">
        <div className="flex items-center gap-2" data-id="element-35">
          <Clock className="w-5 h-5 animate-pulse" data-id="element-36" />
          <span className="font-bold text-sm md:text-base" data-id="element-37">
            🔥 OFERTA ESPECIAL TERMINA EN:
          </span>
        </div>

        <div className="flex items-center gap-2" data-id="element-38">
          <div className="bg-white text-[#D4915D] px-3 py-2 rounded-lg font-bold min-w-[60px]" data-id="element-39">
            <div className="text-2xl" data-id="element-40">
              {String(timeLeft.hours).padStart(2, '0')}
            </div>
            <div className="text-xs" data-id="element-41">HORAS</div>
          </div>
          <span className="text-2xl font-bold" data-id="element-42">:</span>
          <div className="bg-white text-[#D4915D] px-3 py-2 rounded-lg font-bold min-w-[60px]" data-id="element-43">
            <div className="text-2xl" data-id="element-44">
              {String(timeLeft.minutes).padStart(2, '0')}
            </div>
            <div className="text-xs" data-id="element-45">MIN</div>
          </div>
          <span className="text-2xl font-bold" data-id="element-46">:</span>
          <div className="bg-white text-[#D4915D] px-3 py-2 rounded-lg font-bold min-w-[60px]" data-id="element-47">
            <div className="text-2xl" data-id="element-48">
              {String(timeLeft.seconds).padStart(2, '0')}
            </div>
            <div className="text-xs" data-id="element-49">SEG</div>
          </div>
        </div>

        <div className="text-sm md:text-base font-bold" data-id="element-50">
          ⚡ Solo quedan 12 copias
        </div>
      </div>
    </div>;
}